<div class="draft-desktop-heading">
  <span class="draft-search-title label-medium-emphasized">{{ 'receipts.ui.ricerca' | transloco }}</span>

  <button
    matButton="filled"
    type="button"
    class="desktop-new-draft-button"
    *uiCan="CAPS.distintaCrea"
    [routerLink]="['new']"
  >
    <i class="fa-regular fa-plus" aria-hidden="true"></i>
    {{ 'receipts.ui.nuovaDistinta' | transloco }}
  </button>
</div>

<section class="draft-search">
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="draft-date-field">
    <mat-label>{{ 'receipts.ui.dal' | transloco }}</mat-label>
    <input matInput [matDatepicker]="dateFromPicker" [(ngModel)]="dateFrom" [placeholder]="'receipts.ui.datePlaceholder' | transloco" />
    <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker" />
    <mat-datepicker #dateFromPicker />
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="draft-date-field">
    <mat-label>{{ 'receipts.ui.al' | transloco }}</mat-label>
    <input matInput [matDatepicker]="dateToPicker" [(ngModel)]="dateTo" [placeholder]="'receipts.ui.datePlaceholder' | transloco" />
    <mat-datepicker-toggle matIconSuffix [for]="dateToPicker" />
    <mat-datepicker #dateToPicker />
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="draft-status-field">
    <mat-label>{{ 'receipts.ui.statoDistinta' | transloco }}</mat-label>
    <mat-select multiple [(ngModel)]="selectedStatuses">
      @for (status of statusOptions; track status.value) {
        <mat-option [value]="status.value">{{ status.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button matButton="filled" type="button" class="draft-search-button" (click)="cerca()">
    {{ 'receipts.ui.cerca' | transloco }}
  </button>

  <button matButton="outlined" type="button" class="draft-search-button" (click)="resetta()">
    {{ 'receipts.ui.azzeraFiltri' | transloco }}
  </button>

  @if (isLoading) {
    <ui-loading-spinner></ui-loading-spinner>
  } @else {
    <div class="draft-results">
      @for (distinta of distinte; track distinta.id) {
        <div
          class="draft-card"
          role="link"
          tabindex="0"
          (click)="apriDettaglio(distinta.id)"
          (keydown.enter)="apriDettaglio(distinta.id)"
        >
          <div class="draft-card-content">
            <div class="draft-card-column">
              <span class="body-medium-emphasized">
                {{ 'receipts.ui.distintaN2' | transloco: { value0: (distinta.numeroDistinta) } }}
              </span>
              <span class="body-medium">
                {{ 'receipts.ui.data2' | transloco: { value0: (distinta.dataCreazione | date:'dd/MM/yyyy') } }}
              </span>
            </div>

            <div class="draft-card-column draft-card-column--end">
              <span class="body-medium-emphasized">
                {{ distinta.importoTotale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
              </span>
              <span
                class="body-medium deposit-status-badge"
                [ngClass]="statusBadgeClass(distinta.situazione)"
              >
                {{ distinta.situazione }}
              </span>
            </div>
          </div>
          <div class="draft-card-action" aria-hidden="true">
            <i class="fa-regular fa-chevron-right"></i>
          </div>
        </div>
      } @empty {
        <span class="title-small">{{ 'receipts.ui.nessunaDistintaTrovata' | transloco }}</span>
      }
    </div>

    <ui-table-view
      class="draft-desktop-table"
      [columnsInfo]="distinteColumns"
      [data]="distinteTable"
      (rowClicked)="apriDettaglio($event.id)"
    />

    <mat-paginator
      class="draft-paginator"
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[5, 10, 25]"
      [hidePageSize]="true"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  }
</section>

<button matFab extended type="button" class="new-draft-button" *uiCan="CAPS.distintaCrea"
  [routerLink]="['new']">
  <i class="fa-regular fa-plus" aria-hidden="true"></i>
  <span class="new-draft-label title-medium">{{ 'receipts.ui.nuovaDistinta' | transloco }}</span>
</button>
